export const GET_NOTIFICATION_LIST_REQUEST = 'GET_NOTIFICATION_LIST_REQUEST';
export const GET_NOTIFICATION_LIST_SUCCESS = 'GET_NOTIFICATION_LIST_SUCCESS';
export const GET_NOTIFICATION_LIST_FAILURE = 'GET_NOTIFICATION_LIST_FAILURE';
